var _style, _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashbordIcon05(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 62 62",
    style: {
      enableBackground: "new 0 0 62 62"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFB177;}\r\n\t.st1{fill:#545C66;}\r\n\t.st2{fill:#CCD1D9;}\r\n\t.st3{fill:#4A89DC;}\r\n\t.st4{fill:#5D9CEC;}\r\n\t.st5{fill:#E6E9ED;}\r\n\t.st6{fill:#402C1E;}\r\n\t.st7{fill:#EAC6BB;}\r\n\t.st8{fill:#D3B1A9;}\r\n\t.st9{fill:#48CFAD;}\r\n\t.st10{fill:#37BC9B;}\r\n\t.st11{fill:#656D78;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 31,
    cy: 31,
    r: 30.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36,21.2c-0.3,0-0.5-0.2-0.5-0.5v-1.9c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v1.9 C36.5,21,36.3,21.2,36,21.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.2,21.2c-0.3,0-0.5-0.2-0.5-0.5v-1.9c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v1.9 C42.7,21,42.5,21.2,42.2,21.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.1,34.1c-0.3,0-0.5-0.2-0.5-0.5v-1.4c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v1.4 C39.6,33.9,39.4,34.1,39.1,34.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M39.1,40.3c-0.3,0-0.5-0.2-0.5-0.5V37c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v2.9 C39.6,40.1,39.4,40.3,39.1,40.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M37.2,42.2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5c0.8,0,1.4-0.6,1.4-1.4c0-0.3,0.2-0.5,0.5-0.5 c0.3,0,0.5,0.2,0.5,0.5C39.6,41.1,38.5,42.2,37.2,42.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M37.2,42.2h-4c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h4c0.3,0,0.5,0.2,0.5,0.5S37.5,42.2,37.2,42.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M43.6,26.5v4.3l-1.4,1.4h-3.1H36l-1.4-1.4v-4.3H43.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M43.6,20.8v5.7h-9v-5.7H36h6.2H43.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M31.2,24.1V27L29.3,25c0,0-2.2,1-4.8,1s-4.8-1-4.8-1l-1.9,1.9v-2.4c0-3.2,2.6-5.7,5.7-5.7h4.8v2.4 C30,21.2,31.2,22.5,31.2,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M31.2,27v-2.9c0-1.6-1.3-2.9-2.9-2.9v-2.4h-1.9v2.4c0,1.1,0.9,1.9,1.9,1.9c0.5,0,1,0.4,1,1v1L31.2,27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M27.4,35.4v2.1l-2.9,3.8l-2.9-3.8v-2.1c0.9,0.4,1.8,0.6,2.9,0.6C25.6,36,26.6,35.8,27.4,35.4L27.4,35.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M31.2,27v2.4c0,2.7-1.6,5-3.8,6c-0.9,0.4-1.8,0.6-2.9,0.6c-1,0-2-0.2-2.9-0.6c-2.3-1.1-3.8-3.4-3.8-6v0v-2.4 l1.9-1.9c0,0,2.2,1,4.8,1s4.8-1,4.8-1L31.2,27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M29.3,25L29.3,25l0,4.3c0,2.7-1.6,5-3.8,6c-0.6,0.3-1.2,0.5-1.9,0.6c0.3,0,0.6,0.1,1,0.1c1,0,2-0.2,2.9-0.6 c2.3-1.1,3.8-3.4,3.8-6V27L29.3,25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M33.1,41.7v1.9H16v-2.8v-0.1c0-1.8,1.5-3.3,3.3-3.3h2.4l2.9,3.8l2.9-3.8h2.4c1.8,0,3.3,1.5,3.3,3.3v0.1V41.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M29.8,37.4h-1.9c1.8,0,3.3,1.5,3.3,3.3v0.1v0.9v1.9h1.9v-1.9v-0.9v-0.1C33.1,38.9,31.7,37.4,29.8,37.4 L29.8,37.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M45.5,19.3H33.1c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h12.4c0.3,0,0.5,0.2,0.5,0.5S45.8,19.3,45.5,19.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M42.2,32.7H36c-0.1,0-0.2,0-0.3-0.1l-1.4-1.4c-0.1-0.1-0.1-0.2-0.1-0.3v-10c0-0.3,0.2-0.5,0.5-0.5h9 c0.3,0,0.5,0.2,0.5,0.5v10c0,0.1-0.1,0.2-0.1,0.3l-1.4,1.4C42.4,32.6,42.3,32.7,42.2,32.7z M36.2,31.7H42l1.2-1.2v-9.3H35v9.3 L36.2,31.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M45.5,18.4c-0.3,0-0.5,0.2-0.5,0.5v24.8h1V18.9C46,18.6,45.8,18.4,45.5,18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M40,36.5c0,0.3-0.2,0.5-0.5,0.5h-1c-0.3,0-0.5-0.2-0.5-0.5v-2.4c0-0.3,0.2-0.5,0.5-0.5h1 c0.3,0,0.5,0.2,0.5,0.5V36.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M39.6,33.6h-0.5h-0.5c-0.3,0-0.5,0.2-0.5,0.5v1H40v-1C40,33.8,39.8,33.6,39.6,33.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashbordIcon05);
export default __webpack_public_path__ + "static/media/dashbord-icon-05.450ef0f71b7496a9f1058fb5419ce878.svg";
export { ForwardRef as ReactComponent };